import AppRoutes from "./routes/AppRoutes";
import './assets/css/custom.css'
import 'react-bootstrap-typeahead/css/Typeahead.css';
import AuthProvider from "./Contexts/AuthContext";
import { CookiesProvider } from 'react-cookie';

const App = () => {
  return (
    <div>
     <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </CookiesProvider>

    </div>
  );
}

export default App;
